export const languages = {
	'en-US': [
		{
			name: 'English',
			value: 'en-US',
			width: 85,
		},
		{
			name: 'Portuguese',
			value: 'pt-BR',
			width: 85,
		},
	],
	'pt-BR': [
		{
			name: 'Inglês',
			value: 'en-US',
			width: 105,
		},
		{
			name: 'Português',
			value: 'pt-BR',
			width: 105,
		},
	],
};
